import { defineStore } from 'pinia';
import { skillBadgeApi } from '@/services/skillBadgeService';

const api = skillBadgeApi;

export const useSkillBadgesStore = defineStore('skillBadges', {
  state: () => ({
    badgeNotifications: [],
    badgeInformation: {},
  }),

  actions: {
    async fetchUserSkillBadges(auxo_user_id) {
      const badges = await api.getUserSkillBadges(auxo_user_id);
      if (badges) {
        badges.forEach(badge => {
          this.badgeInformation[badge.badge_id] = badge;
        });
      }
      return badges;
    },

    async setNotificationsToSeen(auxo_user_id, badge_id, tier_number) {
      return await api.setNotificationsToSeen(
        auxo_user_id,
        badge_id,
        tier_number
      );
    },

    async getUnseenNotifications(auxo_user_id) {
      const notifications = await api.getUnseenNotifications(auxo_user_id);
      if (notifications) {
        this.badgeNotifications = notifications;
      }
      return notifications;
    },

    triggerNotificationModal(badgeId, tierNumber) {
      let badge = this.getBadgeInformation(badgeId);
      let achievementDate = badge.achievements.find(
        a => a.tier_number === tierNumber
      )?.achievement_date;

      let achievement = {
        auxo_user_id: badge.auxo_user_id,
        badge_id: badgeId,
        tier_number: tierNumber,
        badge_name: badge.badge_name,
        badge_description: badge.badge_description,
        achievement_date: achievementDate,
      };
      this.badgeNotifications.push(achievement);
    },
    mockAchievementNotification() {
      let achievement = {
        badge_id: 1,
        tier_number: 4,
        badge_name: 'Coding Mastery',
        badge_description: 'Completed 10 coding challenges',
        achievement_date: new Date().toISOString(),
        auxo_user_id: 123,
      };
      this.badgeNotifications.push(achievement);
    },
  },

  getters: {
    getBadgeInformation: state => badge_id => {
      return state.badgeInformation[badge_id];
    },
    getTierInformation: state => (badge_id, tier_number) => {
      let badge = state.badgeInformation[badge_id];
      if (badge) {
        return badge.tiers.find(t => t.tier_number === tier_number);
      }
      return null;
    },
  },
});
